import { Tile } from "./Tile";

// The built-in avatar set (design 7 §3): 24 tiles of the CC0 set, by id. The store keeps the id (0–23).
const AVATAR_TILES = [
  108, 112, 116, 120, 84, 128, 132, // the winds, 4s (the white dragon is a blank face) and two dragons
  0, 32, 36, 68, 72, 104, // the terminals
  16, 52, 88, // the red fives
  8, 24, 40, 64, 76, 92, 96, 100,
];
export const AVATARS = AVATAR_TILES.length;

export function Avatar(props: { id: number; size?: number }) {
  const size = () => props.size ?? 32;
  return (
    <span class="avatar" style={{ width: `${size()}px`, height: `${size()}px`, "--t": `${size() * 0.62}px` }}>
      <Tile id={AVATAR_TILES[props.id] ?? AVATAR_TILES[0]!} red size="s" />
    </span>
  );
}
